import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { Navigate, useLocation } from "react-router-dom";

export const ProtectedRoute = ({ children }: any) => {
  const isUserLoggedIn = useIsAuthenticated();
  const { inProgress } = useMsal();
  const location = useLocation();

  // Show loading while MSAL is checking authentication
  if (inProgress !== "none") {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <div
            style={{
              border: "4px solid #f3f3f3",
              borderTop: "4px solid #0078d4",
              borderRadius: "50%",
              width: "40px",
              height: "40px",
              animation: "spin 1s linear infinite",
              margin: "0 auto",
            }}
          ></div>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }

  if (!isUserLoggedIn) {
    // Save the location they were trying to visit and redirect to home (MainDashboard)
    return <Navigate to="/" state={{ from: location.pathname }} replace />;
  }

  return children;
};
